import { UserRoleEnum } from '@qse/constants'
import { useBillingStatusStore } from '@qse/stores'
import { useUserStore } from '@qse/stores'
import { useEffect } from 'react'

export const useBillingStatus = () => {
  const { user } = useUserStore()
  const {
    setBillingStatus,
    setSubscriptionStatus,
    setGracePeriodStatus,
    setShowPaymentOverdueBanner,
    addPaymentFailureNotification,
  } = useBillingStatusStore()

  useEffect(() => {
    if (!user) return

    // Mock data based on user role
    const isTenantAdmin = user.userRole === UserRoleEnum.TENANT_ADMIN

    // Show payment overdue banner for tenant admins with past due status
    if (isTenantAdmin && user.tenant?.billingStatus === 'past_due') {
      setShowPaymentOverdueBanner(true)
    }
  }, [
    user,
    setBillingStatus,
    setSubscriptionStatus,
    setGracePeriodStatus,
    setShowPaymentOverdueBanner,
    addPaymentFailureNotification,
  ])

  return {
    // Return any additional billing status utilities if needed
  }
}
